<template>
  <div class="contact-list" :class="`contact-list--${mode}`">
    <div class="contact-list__rows">
      <div v-for="contact in contacts" :key="`${contact.phone}-${contact.forum}`" class="contact-list__row">
        <span class="contact-list__forum" :title="contact.forum">{{ contact.forum }}</span>
        <a :href="`tel:${contact.phone}`" class="contact-list__link" :style="{ color }">
          <span class="contact-list__name">{{ contact.name }}</span>
          <span class="contact-list__phone">{{ contact.phone }}</span>
        </a>
      </div>
    </div>
    <p class="contact-list__hours" :style="{ color }">{{ consultationTime }}</p>
  </div>
</template>

<script>
const technicalSupport = { forum: '技术支持', name: '许工', phone: '16670256305' }

export default {
  name: 'ContactList',
  props: {
    mode: {
      type: String,
      default: 'page',
      validator: value => ['page', 'dialog'].includes(value)
    },
    color: {
      type: String,
      default: '#3c97ed'
    }
  },
  data() {
    return {
      contacts: [technicalSupport],
      consultationTime: '咨询时间：周一至周五9:00-17:00'
    }
  },
  mounted() {
    this.loadContacts()
  },
  methods: {
    async loadContacts() {
      const miceLink = this.$store.state.miceInfo.miceLink
      if (!miceLink) return
      try {
        const result = await this.$http.get(`${this.$baseURL.index.getGroupList()}?miceLink=${encodeURIComponent(miceLink)}`, 1)
        const groups = Array.isArray(result && result.data) ? result.data : []
        const groupContacts = groups
          .filter(group => group && group.name && group.contactName && group.contactPhone)
          .map(group => ({
            forum: group.name,
            name: group.contactName,
            phone: group.contactPhone
          }))
        this.contacts = [...groupContacts, technicalSupport]
      } catch (error) {
        this.contacts = [technicalSupport]
      }
    }
  }
}
</script>

<style lang="less" scoped>
.contact-list {
  width: 100%;
  color: #666;
  font-size: 12px;
}

.contact-list__row {
  min-width: 0;
  line-height: 1.5;
}

.contact-list__forum,
.contact-list__phone {
  white-space: nowrap;
  text-align: left;
}

.contact-list__link {
  text-decoration: none;
  white-space: nowrap;
}

.contact-list__hours {
  margin: 0;
}

.contact-list--page {
  .contact-list__rows {
    margin-top: 30px;
  }

  .contact-list__row {
    display: flex;
    justify-content: space-between;
    padding-right: 20px;
  }

  .contact-list__link {
    width: 180px;
    min-width: 180px;
    display: grid;
    grid-template-columns: 60px 110px;
    column-gap: 10px;
    align-items: center;
    text-align: left;
  }

  .contact-list__name {
    width: 60px;
    display: inline-block;
    white-space: nowrap;
  }

  .contact-list__hours {
    margin-top: 5px;
    line-height: 2;
  }
}

.contact-list--dialog {
  .contact-list__row {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: 8px;
  }

  .contact-list__forum {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .contact-list__link {
    width: 190px;
    min-width: 190px;
    display: grid;
    grid-template-columns: 52px minmax(0, 1fr);
    column-gap: 8px;
    align-items: center;
    text-align: left;
  }

  .contact-list__name {
    white-space: nowrap;
  }

  .contact-list__hours {
    margin: 2px 0;
  }
}
</style>
